<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm label-width="50" inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem label-width="0">
          <ElInput v-model.trim="keyword" :placeholder="placeholder" style="width: 220px" @keyup.enter.native="search">
            <i slot="append" @click="search" class="el-icon-search"></i>
          </ElInput>
        </ElFormItem>
        <ElFormItem label-width="0" v-for="config in selectConfigData" :key="config.id">
          <ElSelect
            v-model="attr[config.valueKey]"
            :multiple="config.multiple"
            :placeholder="config.placeholder"
            collapse-tags
            filterable
            clearable
          >
            <el-option
              v-for="item in dataSource[config.dataKey]"
              :key="item.id"
              :value="item.id"
              :label="item.name"
              style="width: 180px"
            ></el-option>
          </ElSelect>
        </ElFormItem>

        <ElFormItem>
          <DatePick v-model="datetime" @change="search" style="width: 220px"></DatePick>
        </ElFormItem>

        <ElFormItem class="bg-transparent">
          <ElButton type="primary" @click="search">查询</ElButton>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import DatePick from '@/components/date-range-picker/index.vue'

export default {
  name: 'TencentAdFilter',
  components: { DatePick },
  props: {
    placeholder: {
      type: String
    },
    dataSource: {
      require: true,
      type: Object,
      default: () => {}
    }
  },
  computed: {
    attr() {
      return this
    }
  },
  methods: {
    search() {
      const [queryBeginTime, queryEndTime] = this.datetime || ['', '']
      const params = {
        queryBeginTime,
        queryEndTime,
        keyword: this.keyword,
        adAccountId: this.accountId,
        opId: this.opId,
        status: this.status,
        gameId: this.gameId
      }
      this.$emit('on-search', params)
    }
  },
  data() {
    return {
      datetime: [],
      comDate: [],
      keyword: '',
      accountId: '',
      status: '',
      opId: '',
      gameId: '',
      selectConfigData: [
        {
          id: 1,
          placeholder: '选择计划账号',
          dataKey: 'accountData',
          valueKey: 'accountId'
        },
        {
          id: 2,
          placeholder: '选择状态',
          dataKey: 'statusData',
          valueKey: 'status'
        },
        {
          id: 3,
          placeholder: '选择投放人员',
          dataKey: 'opData',
          valueKey: 'opId'
        },
        {
          id: 4,
          placeholder: '选择投放游戏',
          dataKey: 'gameData',
          valueKey: 'gameId'
        }
      ]
    }
  },
  created() {
    const now = moment().format('YYYY-MM-DD')
    this.datetime = [now, now]
    this.comDate = [now, now]
  }
}
</script>
